// extracted by mini-css-extract-plugin
module.exports = {"screenBottomBar":"styles_screenBottomBar__VGFk0"};